<template>
    <div class="ui-tabs-navigation">
        <div
            class="ui-tabs__nav"
            :class="{
                'centered': centered,
                'vertical': vertical,
            }"
        >
            <button
                v-for="(item, index) in items"
                :key="index"
                class="ui-tabs__nav-button"
                :class="{
                    'active': value === index,
                    'opened': isOpened
                }"
                @click="changeTab(index)"
                v-html="item.label"
            />
        </div>
        <div class="ui-tabs__content">
            <slot />
        </div>
    </div>
</template>

<script>
import {defineComponent, ref} from 'vue';

export default defineComponent({
    name: 'TabsNavigation',
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        centered: {
            type: Boolean,
            default: () => false,
        },
        vertical: {
            type: Boolean,
            default: () => false,
        },
    },
    emits: ['input'],
    setup(_, context) {
        const isOpened = ref(false);

        function changeTab(index) {
            context.emit('input', index);
            isOpened.value = !isOpened.value;
        }

        return {
            isOpened,
            changeTab,
        };
    },
});
</script>
